import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialog } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { HasRoleDirective } from 'app/core/directives/has-role.directive';

@Component({
    selector: 'quick-create',
    standalone: true,
    imports: [
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatTooltipModule,
        HasRoleDirective
    ],
    templateUrl: './quick-create.component.html',
    styleUrls: ['./quick-create.component.scss']
})
export class QuickCreateComponent {
    private _dialog = inject(MatDialog);
    private _router = inject(Router);

    /**
     * Create a new project
     */
    createProject(): void {
        console.log('🎯 Opening project creation dialog...');
        import('../../../views/projects/project-create-dialog/project-create-dialog.component').then(m => {
            this._dialog.open(m.ProjectCreateDialogComponent, {
                width: '600px',
                disableClose: false
            });
        });
    }

    /**
     * Create a new honeytoken
     */
    createHoneytoken(): void {
        console.log('🎯 Opening honeytoken creation dialog...');
        import('../../../views/honeytokens/honeytoken-create-dialog/honeytoken-create-dialog.component').then(m => {
            this._dialog.open(m.HoneytokenCreateDialogComponent, {
                width: '800px',
                maxHeight: '90vh',
                disableClose: false,
                data: {
                    mode: 'create'
                }
            });
        });
    }

    /**
     * Create a new user
     */
    createUser(): void {
        console.log('🎯 Opening user creation dialog...');
        import('../../../views/users/user-create-dialog/user-create-dialog.component').then(m => {
            this._dialog.open(m.UserCreateDialogComponent, {
                width: '600px',
                disableClose: false
            });
        });
    }
}
